<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/USnB9G/tc-custom/9780253039774.jpg?1737783648904" alt="This image is the cover for the book Hermann Cohen and the Crisis of Liberalism, New Jewish Philosophy and Thought"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hermann Cohen and the Crisis of Liberalism, New Jewish Philosophy and Thought
      </h1>
      <p class="bookDescription body article font2">
        <b>A fresh look at a nineteenth-century Jewish philosopher whose theology offers a beacon in an illiberal twenty-first century world: “Recommended.” —<i>Choice</i></b><br/><br/>Hermann Cohen is often held to be one of the most important Jewish philosophers of the nineteenth century. Paul E. Nahme, in this new consideration of Cohen, liberalism, and religion, emphasizes the idea of enchantment, or the faith in and commitment to ideas, reason, and critique—the animating spirits that move society forward.<br/><br/>Nahme views Cohen through the lenses of the crises of Imperial Germany—the rise of antisemitism, nationalism, and secularization—to come to a greater understanding of liberalism, its Protestant and Jewish roots, and the spirits of modernity and tradition that form its foundation. Nahme’s philosophical and historical retelling of the story of Cohen and his spiritual investment in liberal theology present a strong argument for religious pluralism and public reason in a world rife with populism, identity politics, and conspiracy theories.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul E. Nahme
      </h2>
      
      <p class="authorDescription body article"><P><P>Paul E. Nahme is Dorot Assistant Professor of Judaic Studies and Assistant Professor of Religious Studies at Brown University. </P></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?603159c8